<template>
  <v-container fluid class="px-0 py-0">
    <drawer-left>
      <template v-slot:left>
        <div class="pr-3">
          <v-select @change="onOrgChange" label="范围" v-model="org" :items="orgs" item-text="name" item-value="id">
          </v-select>
          <label class="grey--text">培训类别</label>
          <tree v-if="treeCfg" :cfg="treeCfg" :itemstamp="treeTimestamp" :default-active-first="false"
            @active="onCategory" />
        </div>
      </template>
      <template v-slot:right>
        <crud v-if="crudCfg" :cfg="crudCfg" :timestamp="crudTimestamp" ref="crud" />
      </template>
    </drawer-left>
  </v-container>
</template>

<script>
import { Crud, Tree, DrawerLeft } from "javaee-fre";
export default {
  name: "clazzrule-repo",
  props: {
    cfg: Object,
  },
  components: {
    crud: Crud,
    tree: Tree,
    "drawer-left": DrawerLeft,
  },
  data() {
    return {
      crudCfg: null,
      crudTimestamp: Date.now(),
      orgs: [],
      org: null,
      treeCfg: null,
      treeTimestamp: Date.now(),
      category: null,
    };
  },
  methods: {
    selected() {
      return this.$refs.crud.selected();
    },
    init() {
      let self = this,
        axios = self.$axios;
      function getCategories() {
        return axios.get("/home/my/crule/categories");
      }
      function getOrgs() {
        return axios.get("/home/my/tenant/org/parent");
      }

      axios.all([getCategories(), getOrgs()]).then(
        axios.spread((r1, r2) => {
          if (r1.data && r1.data.status == "ok") {
            let itemHash = {}, items = [];
            for (let i of r1.data.message) {
              itemHash[i.id] = i;
            }
            for (let i of r1.data.message) {
              if (i.parentId === undefined || i.parentId === null) {
                items.push(i);
              } else {
                let pi = itemHash[i.parentId];
                if (!pi.children) pi.children = [];
                pi.children.push(i);
              }
            }

            self.treeCfg = {
              label: "name",
              id: "value",
              items: items,
            };
            self.treeTimestamp = Date.now();
          }

          let orgs = [
            { name: "平台共享", id: "-" },
            { name: "企业共享", id: 0 },
          ];
          if (r2.data && r2.data.message) {
            orgs.push(...r2.data.message);
          }
          self.orgs = orgs;
          self.org = orgs[0].id;
          let cfg = {
            url: "/home/my/crule",
            detailable: false,
            listItemActions: [
              {
                label: "收藏",
                icon: "favorite_border",
                func(cfg) {
                  this.$favorite(6, cfg.item.id);
                },
              },
              {
                label: "预览",
                icon: "visibility",
                func(cfg) {
                  this.$dialog.component(cfg.item.name, "clazzrule-view", {
                    fullscreen: true,
                    targetId: cfg.item.id,
                  });
                },
              },
            ],
          };
          if (self.cfg) {
            cfg = { ...cfg, ...self.cfg };
          }
          self.fillCrud(cfg);
        })
      );
    },
    onCategory(i) {
      this.category = i ? i.value : null;
      this.fillCrud();
    },
    onOrgChange() {
      this.fillCrud();
    },
    fillCrud(cfg) {
      let self = this,
        noFirst = !cfg;
      if (noFirst) {
        cfg = self.crudCfg;
      }
      if (!cfg) {
        return;
      }
      let params = cfg.params || {};
      if (self.org == "-") {
        params._tenant = true;
        params._org = 0;
      } else {
        params._tenant = null;
        params._org = self.org || 0;
      }
      params._cate = self.category;
      cfg.params = params;
      if (noFirst) {
        self.crudTimestamp = Date.now();
      } else {
        self.crudCfg = cfg;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
